import {
  getNativePlatformType,
  setNativePlatformType,
} from './sessionStorage/sessionStorageOperations';

import { NativePlatformTypes } from '~/types/behavior/nativePlatformType';

/**
 * Check if the current platform is Android
 * @returns {boolean} True if the current platform is Android, false otherwise.
 */
export function isNativeAndroid(): boolean {
  return NativePlatformTypes.Android === getNativePlatformType();
}

/**
 * Check if the current platform is iOS
 * @returns {boolean} True if the current platform is iOS, false otherwise.
 */
export function isNativeIOS(): boolean {
  return NativePlatformTypes.IOS === getNativePlatformType();
}

/**
 * Check if the current platform is Android or iOS
 * @returns {boolean} True if the current platform is Android or iOS, false otherwise.
 */
export function setAndroidNativePlatformType(): void {
  setNativePlatformType(NativePlatformTypes.Android);
}

/**
 * Check if the current platform is Android or iOS
 * @returns {boolean} True if the current platform is Android or iOS, false otherwise.
 */
export function setIOSNativePlatformType(): void {
  setNativePlatformType(NativePlatformTypes.IOS);
}

/**
 * Check if the current platform is Android or iOS
 * @returns {boolean} True if the current platform is Android or iOS, false otherwise.
 */
export function isNativePlatform(): boolean {
  return isNativeAndroid() || isNativeIOS();
}
